import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconProgress25: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="progress-25, ideas, open, status, task"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M19 12C19 8.13401 15.866 5 12 5V12H19Z" fill="currentColor"/></CentralIconBase>;
};

export default IconProgress25;
